import VueRouter, { RouteConfig } from "vue-router";
import routelib from "./routerlib";

const routes: Array<RouteConfig> = [
  {
    path: "/",
    redirect: "/membercontact"
  }, 
  {
    path: "/membercontact/security",
    name: "Security",
    component: () => import("../views/SecurityContact.vue"),
    beforeEnter: routelib.authguard,
    meta: { requiresAuth: true, requiresPrimaryContact: true }
  },
  {
    path: "/membercontact/invoice",
    name: "Invoice",
    component: () => import("../views/InvoiceContact.vue"),
    beforeEnter: routelib.authguard,
    meta: { requiresAuth: true, requiresPrimaryContact: true }
  },
  {
    path: "/membercontact/payment",
    name: "Payment",
    component: () => import("../views/PaymentContact.vue"),
    beforeEnter: routelib.authguard,
    meta: { requiresAuth: true, requiresPrimaryContact: true }
  },
  {
    path: "/membercontact/legal",
    name: "Legal",
    component: () => import("../views/LegalContact.vue"),
    beforeEnter: routelib.authguard,
    meta: { requiresAuth: true, requiresPrimaryContact: true }
  },
  {
    path: "/membercontact/qualification",
    name: "Qualification",
    component: () => import("../views/QualificationContact.vue"),
    beforeEnter: routelib.authguard,
    meta: { requiresAuth: true, requiresPrimaryContact: true }
  },    
  {
    path: "/changepassword",
    name: "ChangePassword",
    beforeEnter: routelib.authguard,
    component: () => import("../views/ChangePassword.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/membercontact",
    name: "MemberContact",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/MemberContact.vue"),
    beforeEnter: routelib.authguard,
    meta: { requiresAuth: true }
  },
  {
    path: "/membercontact/:component/Error",
    name: "ComponentError",
    component: () => import("../views/ErrorView.vue")
  },
  {
    path: "/membercontact/Error",
    name: "ErrorView",
    component: () => import("../views/ErrorView.vue")
  }
];

export default routes;
